enum DayIntervalType {
  CONSECUTIVE_DAYS = 'consecutiveDays',
  EVERY_DAY = 'everyDay',
  INDIVIDUAL_DAYS = 'individualDays'
}

enum SearchType {
  ONE_WAY = 'one_way',
  ROUND_TRIP = 'round_trip'
}

enum SignInOptions {
  GUEST_CHECKOUT = 'guest_checkout',
  SIGN_IN = 'sign_in'
}

export { DayIntervalType, SearchType, SignInOptions };
